
























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import LaporanPpra from "@/services/LaporanPpra";
import { localISODate } from "@/utils/localDate";
import { PpraAware, PpraFilter, PpraRingkasan, PpraRow } from "@/types/ppra";

const MAX_PERIODE_HARI = 92;

@Component({
  components: { UnitRuangPicker }
})
export default class LaporanPpraPage extends Vue {
  menuStart = false;
  menuEnd = false;
  loading = false;
  loadingPdf = false;
  loadingExcel = false;

  rows: PpraRow[] = [];
  ringkasan: PpraRingkasan | null = null;

  filter: PpraFilter = {
    tgl_start: localISODate(),
    tgl_end: localISODate(),
    unit: [],
    aware: [],
    antibiotik: "",
    hanya_penerima_antibiotik: true
  };

  awareItems = [
    { text: "Access", value: "access" },
    { text: "Watch", value: "watch" },
    { text: "Reserve", value: "reserve" }
  ];

  headers = [
    { text: "No", value: "no", width: 60, sortable: false },
    { text: "Pasien", value: "nama_pasien", width: 200, sortable: false },
    { text: "Ruang", value: "unit_nama", width: 150, sortable: false },
    { text: "Masuk", value: "tgl_masuk", width: 110, sortable: false },
    { text: "Lama Rawat", value: "lama_rawat_label", width: 130, sortable: false },
    { text: "Diagnosa Utama", value: "diagnosa_utama", width: 230, sortable: false },
    { text: "Antibiotik", value: "antibiotik", width: 180, sortable: false },
    { text: "AWaRe", value: "aware_label", width: 110, sortable: false },
    { text: "Rute", value: "rute", width: 80, sortable: false },
    { text: "Dosis", value: "dosis", width: 100, sortable: false },
    { text: "Periode Pemberian", value: "periode_ab", width: 190, sortable: false },
    { text: "DOT", value: "dot", width: 70, sortable: false },
    { text: "DPJP", value: "dpjp", width: 180, sortable: false }
  ];

  get today() {
    return localISODate();
  }

  get tiles() {
    const r = this.ringkasan;

    if (!r) {
      return [];
    }

    return [
      { label: "Pasien Ranap", nilai: r.jumlah_pasien_ranap, color: "blue-grey darken-1" },
      {
        label: "Menerima Antibiotik",
        nilai: `${r.jumlah_pasien_antibiotik}${
          r.persen_pasien_antibiotik === null ? "" : ` (${r.persen_pasien_antibiotik}%)`
        }`,
        color: "indigo darken-1"
      },
      { label: "Item Antibiotik", nilai: r.jumlah_item_antibiotik, color: "blue darken-2" },
      {
        label: "Access",
        nilai: `${r.aware.access}${r.aware.persen_access === null ? "" : ` (${r.aware.persen_access}%)`}`,
        color: "green darken-2"
      },
      {
        label: "Watch",
        nilai: `${r.aware.watch}${r.aware.persen_watch === null ? "" : ` (${r.aware.persen_watch}%)`}`,
        color: "amber darken-3"
      },
      {
        label: "Reserve",
        nilai: `${r.aware.reserve}${r.aware.persen_reserve === null ? "" : ` (${r.aware.persen_reserve}%)`}`,
        color: "red darken-2"
      }
    ];
  }

  /** Cermin guard MAX_PERIODE_HARI di server supaya tidak menembak request yang pasti 422. */
  get peringatanPeriode() {
    if (!this.filter.tgl_start || !this.filter.tgl_end) {
      return "Tanggal mulai dan selesai harus diisi.";
    }

    const mulai = new Date(this.filter.tgl_start + "T00:00:00");
    const selesai = new Date(this.filter.tgl_end + "T00:00:00");

    if (selesai < mulai) {
      return "Tanggal selesai tidak boleh mendahului tanggal mulai.";
    }

    const hari = Math.round((selesai.getTime() - mulai.getTime()) / 86400000);

    return hari > MAX_PERIODE_HARI
      ? `Periode maksimal ${MAX_PERIODE_HARI} hari (saat ini ${hari} hari). Persempit rentangnya.`
      : "";
  }

  formatTgl(nilai: string) {
    if (!nilai) {
      return "";
    }

    const [t, b, h] = nilai.split("-");

    return `${h}-${b}-${t}`;
  }

  warnaAware(aware: PpraAware) {
    const peta: Record<PpraAware, string> = {
      access: "green darken-2",
      watch: "amber darken-3",
      reserve: "red darken-2"
    };

    return peta[aware] || "grey";
  }

  async tampilkan() {
    this.loading = true;

    try {
      const res = await LaporanPpra.preview(this.filter);
      this.rows = res.rows;
      this.ringkasan = res.ringkasan;
    } catch (e) {
      // Pesan galat sudah ditampilkan ErrorAlert di service.
    } finally {
      this.loading = false;
    }
  }

  async cetakPdf() {
    this.loadingPdf = true;

    try {
      await LaporanPpra.openPdf(this.filter);
    } catch (e) {
      // ditangani service
    } finally {
      this.loadingPdf = false;
    }
  }

  async unduhExcel() {
    this.loadingExcel = true;

    try {
      await LaporanPpra.downloadExcel(this.filter);
    } catch (e) {
      // ditangani service
    } finally {
      this.loadingExcel = false;
    }
  }
}
